//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { KidsPlayworldLargeSVG } from './svg'

interface KidsPlayworldLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const KidsPlayworldLargeIcon: React.FC<KidsPlayworldLargeIconProps> = forwardRef<
  KidsPlayworldLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon ref={ref} boxSize={boxSize} as={KidsPlayworldLargeSVG} sx={sx} />
))
